<template>
  <div>
    <div class="flex-between cursorpointer">
      <div></div>
      <div class="flex-betweennowrap" style="height: 60px">
        <div
          class="margin-right20 hight20"
          @click="dialogVisiblegn = true"
          style="position: relative; top: -3px"
        >
          <img src="@/assets/barsvg/icon／24sz.svg" alt="" />
        </div>
        <div
          class="margin-right20 hight20"
          style="position: relative; top: -3px"
        >
          <img src="@/assets/barsvg/icon／24bz.svg" alt="" />
        </div>
        <div
          class="margin-right20 hight20"
          @click="dialogVisible()"
          style="position: relative; top: -3px"
        >
          <img src="@/assets/barsvg/xx／icon／24sm.svg" alt="" />
        </div>
        <div
          class="margin-right10 pad-right20 rightbor hight20"
          style="position: relative; top: -3px"
          @click="toMessageCenter()"
        >
          <el-badge :value="messgeval" :max="99" class="item">
            <img src="@/assets/barsvg/icon／24xx.svg" alt="" />
          </el-badge>
        </div>

        <div class="f12 rightbor authtext margin-left10" @click="Onemuch">
          进入企业中心
        </div>
        <div class="headimg-box margin-left20">
          <!-- <el-image :src="avatar" class="head-img"></el-image> -->
          <el-image :src="avatar" class="head-img">
            <div slot="error" class="head-img">
              <img src="@/assets/barsvg/100mrtx200.png" alt="" />
            </div>
          </el-image>
        </div>
        <el-dropdown trigger="click" @visible-change="visiblechanges($event)">
          <div class="f14 pad-right10 hight20">
            <span class="visitits"
              >{{ realname }} <i class="el-icon-arrow-down"></i
            ></span>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              ><p class="dropdown-content bordert-bf" @click="centerMenu()">
                个 人 中 心
              </p></el-dropdown-item
            >
            <el-dropdown-item
              ><p class="dropdown-content" @click="Logout()">
                退 出 登 录
              </p></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <el-dialog
      title="企业认证"
      :visible.sync="outerVisible"
      center
      :close-on-click-modal="false"
      :show-close="true"
      width="30%"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        class="demo-ruleForm width98 margin-auto"
      >
        <el-form-item label="">
          <p>企业名称 <span class="Required">*</span></p>

          <el-input
            :maxlength="0"
            placeholder="请输入企业名称"
            v-model="ruleForm.pipo"
            @click.native="innerVisible = true"
          ></el-input>
        </el-form-item>
        <el-form-item label="" class="photo">
          <p>营业执照扫描件 <span class="Required">*</span></p>

          <el-upload
            class="avatar-uploader"
            :action="Apisrc"
            name="images"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :on-error="handleerror"
            :on-change="onchange"
            :data="user"
            :headers="head"
          >
            <img v-if="scanning" :src="scanning" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="Photodetails f12">
            <p>请上传企业营业执照扫描件</p>
            <p>格式为:jpg或png</p>
            <p>大小不超过2M</p>
          </div>
        </el-form-item>
        <el-form-item label="" class="photo">
          <p>法人身份证正面 <span class="Required">*</span></p>

          <el-upload
            class="avatar-uploader"
            :action="Apisrc"
            name="images"
            :show-file-list="false"
            :on-success="positivehandleAvatarSuccess"
            :on-error="positivehandleerror"
            :on-change="positiveonchange"
            :data="user"
            :headers="head"
          >
            <img v-if="positive" :src="positive" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="Photodetails f12">
            <p>请上传法人身份证正面（人像）</p>
            <p>格式为:jpg或png</p>
            <p>大小不超过2M</p>
          </div>
        </el-form-item>
        <el-form-item label="" class="photo">
          <p>法人身份证背面</p>
          <span class="Required">*</span>

          <el-upload
            class="avatar-uploader"
            :action="Apisrc"
            name="images"
            :show-file-list="false"
            :on-success="backhandleAvatarSuccess"
            :on-error="backhandleerror"
            :on-change="backonchange"
            :data="user"
            :headers="head"
          >
            <img v-if="back" :src="back" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="Photodetails f12">
            <p>请上传法人身份证背面（国徽）</p>
            <p>格式为:jpg或png</p>
            <p>大小不超过2M</p>
          </div>
        </el-form-item>
        <el-form-item label="" prop="name">
          <p>用户联系人 <span class="Required">*</span></p>

          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <div class="textalign-right margin-top20">
          <el-button size="small" type="primary" @click="submitForm()"
            >提交</el-button
          >
        </div>
      </el-form>
      <el-dialog
        title="企业检索"
        center
        :close-on-click-modal="false"
        :show-close="true"
        width="25%"
        :visible.sync="innerVisible"
        append-to-body
      >
        <el-input v-model="search" class="width98 margin-bot10 margin-top20">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="searchEnterprise()"
          ></el-button>
        </el-input>
        <p
          class="
            width98
            margin-auto
            flex-between
            pad-top10 pad-bot10
            bodelbind
            f14
          "
          v-for="(item, index) in allenterprise"
          :key="index"
        >
          <span class="width85 pad-left10">{{ item.companyName }}</span
          ><span class="bluecolor width15" @click="Applybinding(index)"
            >申请绑定</span
          >
        </p>
      </el-dialog>
    </el-dialog>
    <el-dialog
      title="请选择企业"
      :visible.sync="dialogVisibledrawer"
      :close-on-click-modal="false"
      :show-close="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="drawerbox"
    >
      <div class="width96 margin-auto">
        <el-input
          placeholder="请输入内容"
          v-model="input3"
          @input="oninput"
          class="margin-top20 margin-bot10"
        >
          <el-button
            @click="searchbut"
            slot="append"
            icon="el-icon-search"
          ></el-button>
        </el-input>
      </div>
      <div class="enterprisebox" @scroll="scrollEvent">
        <div
          class="newenterprise"
          @click="onConfirm(index)"
          v-for="(item, index) in page"
          :key="index"
        >
          {{ item.company }}
        </div>
      </div>
      <div class="personchange cursorpointer">
        <div class="bluecolor paddingleft10" @click="outerVisible = true">
          <span> 没有找到您的企业？</span>
        </div>
        <div class="bluecolor paddingleft10" @click="changeperson()">
          切换个人版
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblegn"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="20%"
      class="errorbox"
    >
      <p class="textalign-left f16">页面布局设置</p>

      <div class="flex-betweenwrap margin-top20">
        <el-switch
          class="width100"
          v-model="value"
          active-text="默认打开检 索框"
          @change="keychange($event)"
        >
        </el-switch>

        <el-switch
          class="width100 margin-top10"
          v-model="value1"
          active-text="使用精简左边栏"
          @change="leftchange($event)"
        >
        </el-switch>
        <el-switch
          class="width100 margin-top10"
          v-model="value2"
          active-text="关闭表单历史"
          @change="removechange($event)"
        >
        </el-switch>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  boundEnterprise,
  personalInformation,
  boundchange,
  companysearch,
  userapply,
} from "@/api/personal/personal.api";
import { messageperson } from "@/api/personal/personal.api";
import { config } from "@/api/login/login.api";
import VueCookie from "vue-cookie";
import BUS from "../BUS/BUS";

export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,

      dialogVisiblegn: false,
      phonnumber: "",
      avatar: "",
      title: "",
      company: [],
      page: "",
      bs: "bottom",
      outerVisible: false,
      innerVisible: false,
      ruleForm: {
        pipo: "",
        name: "",
      },
      user: {
        images: "",
      },
      Apisrchead: "",
      userhead: {
        images: "",
      },
      head: {
        token: window.sessionStorage.getItem("token"),
      },
      formgr: {
        realname: "",
        nickname: "",
        mobile: "",
        address: "",
      },
      scanning: "",
      positive: "",
      realname: "",
      back: "",
      search: "",
      allenterprise: [],
      dialogVisibledrawer: false,
      direction: "btt",
      titlespan: "请选择企业",
      input3: "",
      Apisrc: "",
      value: true,
      value1: false,
      value2: false,
      numchange: 0,
      changeright: false,
      changeleft: true,
      author: "",
      authority_text: "",
      block_chain_number: "",
      icp_number: "",
      police_number: "",
      service_tel: "",
      breadList: [], // 路由集合
      messgeval: 0,
      thisNum: 1,
      page1: [],
    };
  },
  inject: ["reload"],
  watch: {
    $route() {
      this.getBreadcrumb();
    },
  },
  methods: {
    //滚动条触发事件
    scrollEvent(e) {
      if (
        e.srcElement.scrollTop + e.srcElement.clientHeight >=
        e.srcElement.scrollHeight
      ) {
        // // 获取企业
        boundEnterprise({ limit: 30, page: ++this.thisNum }).then((res) => {
          if (res.data.code == 200) {
            // this.page = res.data.data.data;
            if (res.data.data.data.length == 0) {
              return;
            } else {
              this.page1 = res.data.data.data;
              this.page1.forEach((i) => {
                this.page.push(i);
              });
            }
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    visiblechange(e) {
      if (e == true) {
        document.querySelector(".visitit").style.color = "#52C6CC";
      } else {
        document.querySelector(".visitit").style.color = "#353A44";
      }
    },
    visiblechanges(e) {
      if (e == true) {
        document.querySelector(".visitits").style.color = "#52C6CC";
      } else {
        document.querySelector(".visitits").style.color = "#353A44";
      }
    },

    isHome(route) {
      return route.name === "home";
    },
    getBreadcrumb() {
      let matched = this.$route.matched;
      //如果不是首页
      // if (!this.isHome(matched[0])) {
      //   matched = [{ path: "/home", meta: { name: "首页" } }].concat(matched);
      // }
      this.breadList = matched;
      // this.breadList.unshift({ path: "/home", meta: { name: "首页" } })
    },

    // 切换按钮
    Onemuch() {
      if (window.sessionStorage.getItem("default") != 0) {
        this.dialogVisibledrawer = true;
      } else {
        this.$router.push({
          path: "/Personal-Center/Enterprise-Certification",
        });
      }
    },
    onConfirm(index) {
      this.drawer = false;
      this.$confirm("是否切换到 " + this.page[index].company, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 切换主企业
          boundchange({ id: this.page[index].ent_id }).then((res) => {
            if (res.data.code == 200) {
              // this.title = this.page[index].company;
              // window.sessionStorage.setItem(
              //   "companytitle",
              //   this.page[index].company
              // );
              window.sessionStorage.setItem("id", this.page[index].id);
              window.sessionStorage.setItem("default", this.page[index].ent_id);
              this.$router.push({ path: "/home/homepage" });
              this.reload();
            } else {
              this.drawer = false;
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 切换个人版
    changeperson() {
      this.$confirm("是否切换到个人版？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          boundchange({}).then((res) => {
            if (res.data.code == 200) {
              // this.title = "个人版";
              window.sessionStorage.setItem("default", 0);
              window.sessionStorage.setItem("id", 0);
              // window.sessionStorage.setItem("companytitle", "个人版");
              // this.$router.push({ path: "/personalhomepage" });
              this.reload();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 个人中心
    centerMenu() {
      window.sessionStorage.setItem("default", "个人中心");
      BUS.$emit("default", "个人中心");
      this.$router.push({ path: "/Personal-Center/personal-homepage" });
    },
    searchbut() {
      if (this.input3 != "") {
        // // 获取企业
        boundEnterprise({ _keywords: this.input3 }).then((res) => {
          if (res.data.code == 200) {
            this.page = res.data.data.data;
            this.title = this.page[0].company;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        // // 获取企业
        boundEnterprise().then((res) => {
          if (res.data.code == 200) {
            this.page = res.data.data.data;
            this.title = this.page[0].company;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    oninput() {
      if (this.input3 == "") {
        // // 获取企业
        boundEnterprise().then((res) => {
          if (res.data.code == 200) {
            this.page = res.data.data.data;
            this.title = this.page[0].company;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    // 营业执照
    handleAvatarSuccess(response, res, file) {
      if (response.msg == "上传文件后缀不允许") {
        this.dialogVisiblenull = true;
        this.errormessage = response.msg;
      } else {
        this.scanning = window.g.Apisrc + response.data.url;
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success",
        });
      }
    },
    handleerror(error, file, fileList) {
      let myError = error.toString(); //转字符串
      myError = myError.replace("Error: ", ""); // 去掉前面的" Error: "
      myError = JSON.parse(myError); //转对象
      this.$loadings.hide(); // 隐藏loading
      if (myError.code == 401) {
        this.dialogVisiblenull = false;
        this.$router.push({ path: "/login" });
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = myError.msg;
      }
    },
    onchange(file, fileList) {
      this.user.images =
        document.getElementsByClassName("el-upload__input")[0].value;
    },
    //法人身份证正面
    positivehandleAvatarSuccess(response, res, file) {
      if (response.msg == "上传文件后缀不允许") {
        this.dialogVisiblenull = true;
        this.errormessage = response.msg;
      } else {
        this.positive = window.g.Apisrc + response.data.url;
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success",
        });
      }
    },
    positivehandleerror(error, file, fileList) {
      let myError = error.toString(); //转字符串
      myError = myError.replace("Error: ", ""); // 去掉前面的" Error: "
      myError = JSON.parse(myError); //转对象
      this.$loadings.hide(); // 隐藏loading
      if (myError.code == 401) {
        this.dialogVisiblenull = false;
        this.$router.push({ path: "/login" });
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = myError.msg;
      }
    },
    positiveonchange(file, fileList) {
      this.user.images =
        document.getElementsByClassName("el-upload__input")[0].value;
    },
    //法人身份证背面
    backhandleAvatarSuccess(response, res, file) {
      if (response.msg == "上传文件后缀不允许") {
        this.dialogVisiblenull = true;
        this.errormessage = response.msg;
      } else {
        this.back = window.g.Apisrc + response.data.url;
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success",
        });
      }
    },
    backhandleerror(error, file, fileList) {
      let myError = error.toString(); //转字符串
      myError = myError.replace("Error: ", ""); // 去掉前面的" Error: "
      myError = JSON.parse(myError); //转对象
      this.$loadings.hide(); // 隐藏loading
      if (myError.code == 401) {
        this.dialogVisiblenull = false;
        this.$router.push({ path: "/login" });
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = myError.msg;
      }
    },
    backonchange(file, fileList) {
      this.user.images =
        document.getElementsByClassName("el-upload__input")[0].value;
    },
    // 退出登录
    Logout() {
      window.sessionStorage.clear();
      localStorage.clear();
      let token = VueCookie.get("token");
      VueCookie.set("token", token, -2); //删除
      this.$router.push({ path: "/login" });
    },

    // 企业认证申请
    submitForm() {
      if (this.scanning == "") {
        this.dialogVisiblenull = true;
        this.errormessage = "请上传营业执照扫描件";
        return;
      }
      if (this.positive == "") {
        this.dialogVisiblenull = true;
        this.errormessage = "请上传法人身份证正面(人像)";
        return;
      }
      if (this.back == "") {
        this.dialogVisiblenull = true;
        this.errormessage = "请上传法人身份证背面(国徽)";
        return;
      }
      userapply({
        realname: this.ruleForm.name,
        company: this.ruleForm.pipo,
        id_front: this.positive,
        id_backend: this.back,
        cert_file: this.scanning,
      }).then((res) => {
        if (res.data.code == 200) {
          this.outerVisible = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 企业关键字检索
    searchEnterprise() {
      companysearch({ company: this.search }).then((res) => {
        if (res.data.code == 200) {
          this.allenterprise = res.data.data;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 申请绑定
    Applybinding(index) {
      this.innerVisible = false;
      this.ruleForm.pipo = this.allenterprise[index].companyName;
    },
    // 关键词检索change
    keychange($event) {
      BUS.$emit("serchkey", $event);
    },
    // 左边栏
    leftchange($event) {
      window.sessionStorage.setItem("leftSimplifys", $event);
      BUS.$emit("leftSimplify", $event);
    },
    changelefts() {
      this.value1 = true;
      BUS.$emit("leftSimplify", true);
      this.changeleft = false;
      this.changeright = true;
    },
    changerights() {
      this.value1 = false;
      BUS.$emit("leftSimplify", false);
      this.changeleft = true;
      this.changeright = false;
    },
    // 清除历史记录
    removechange($event) {
      BUS.$emit("removehistory", $event);
    },
    // 二维码
    dialogVisible() {
      BUS.$emit("dialogVisible", 1);
    },
    // 消息中心
    toMessageCenter() {
      this.$router.push({ path: "/Personal-Center/message-reminds" });
    },
    // 我的企业cy
    toMybusiness() {
      this.$router.push({ path: "/business-management/Member-Management" });
    },
  },
  created() {
    this.getBreadcrumb();
    config().then((res) => {
      this.author = res.data.data.author;
      this.block_chain_number = res.data.data.block_chain_number;
      this.icp_number = res.data.data.icp_number;
      this.police_number = res.data.data.police_number;
      this.service_tel = res.data.data.service_tel;
    });

    this.Apisrc = window.g.ApiUrl + "/oss_form";

    BUS.$on("serchkey", (data) => {
      this.value = data;
    });
    this.phonnumber = window.sessionStorage.getItem("phon");

    // // 获取企业
    boundEnterprise({ limit: 30 }).then((res) => {
      if (res.data.code == 200) {
        this.page = res.data.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    // 获取个人信息
    const id = window.sessionStorage.getItem("id");
    personalInformation({ id: id }).then((res) => {
      if (res.data.code == 200) {
        if (
          res.data.data.company.company == undefined ||
          res.data.data.company.company == null ||
          res.data.data.company.company == ""
        ) {
          this.title == "个人版";
        } else {
          this.title = res.data.data.company.company;
        }
        if (
          res.data.data.bind == undefined ||
          res.data.data.bind == null ||
          res.data.data.bind == ""
        ) {
          this.authority_text = "";
        } else {
          this.authority_text = res.data.data.bind.authority_text;
        }

        window.sessionStorage.setItem(
          "default",
          res.data.data.user.default_cid
        );
        if (res.data.data.user.avatar.indexOf("http://") == -1) {
          this.avatar = window.g.Apisrc + res.data.data.user.avatar;
        } else {
          this.avatar = res.data.data.user.avatar;
        }
        window.sessionStorage.setItem("personid", res.data.data.user.id);
        this.phonnumber = res.data.data.user.mobile;
        this.nickname = res.data.data.user.nickname;
        this.realname = res.data.data.user.realname;
        this.mobile = res.data.data.user.mobile;
        this.formgr.address = res.data.data.user.address;
        this.formgr.nickname = res.data.data.user.nickname;
        this.formgr.realname = res.data.data.user.realname;
        this.formgr.mobile = res.data.data.user.mobile;
        if (window.sessionStorage.getItem("default") == 0) {
          this.title = "个人版";
        } else {
          window.sessionStorage.setItem(
            "companytitle",
            res.data.data.company.company
          );
        }
        window.sessionStorage.setItem("companyentid", res.data.data.company.id);
        window.sessionStorage.setItem(
          "authority_text",
          res.data.data.bind.authority_text
        );
        window.sessionStorage.setItem(
          "authority",
          res.data.data.bind.authority
        );
        window.sessionStorage.setItem("nickname", res.data.data.user.nickname);
        window.sessionStorage.setItem("mobile", res.data.data.user.mobile);
        window.sessionStorage.setItem("realname", res.data.data.user.realname);
        window.sessionStorage.setItem("deptitle", res.data.data.dep.finance);
        window.sessionStorage.setItem("address", res.data.data.user.address);
        window.sessionStorage.setItem("last_ip", res.data.data.user.last_ip);
        window.sessionStorage.setItem(
          "personcreate_time",
          res.data.data.user.create_time
        );
        window.sessionStorage.setItem("avatar", this.avatar);
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    messageperson({ page: this.thisNums }).then((res) => {
      if (res.data.code == 200) {
        this.messgeval = res.data.data.total;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
  mounted() {
    BUS.$on("avatar", (data) => {
      this.avatar = data;
    });
    BUS.$on("send", (data) => {
      this.title = data;
    });

    BUS.$on("indent", (data) => {
      if (data == true) {
        this.changeleft = false;
        this.changeright = true;
      } else {
        this.changeleft = true;
        this.changeright = false;
      }
    });
  },
};
</script>

<style scoped >
.bodelbind:hover {
  background: #ecf8f9;
  border-radius: 3px;
}
.item >>> .el-badge__content {
  height: 14px;
  line-height: 14px;
  padding: 0 3px;
}
.el-breadcrumb ::v-deep .el-breadcrumb__inner {
  color: #101010 !important;
  font-weight: 500;
}
.breadcrumbitem ::v-deep .el-breadcrumb__inner {
  color: #97a8be !important;
  font-weight: 500;
}
.header-bode {
  /* line-height: 60px; */
  color: rgb(128, 126, 126);
}
.dropdown-content {
  width: 100px;
  text-align: center;
}
.dropdown-contents {
  width: 140px;
  text-align: left;
  padding: 3px 0 3px 0;
}
.right-top {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding-top: 10px;
}
.white {
  color: white;
}
.svgfff {
  /* stroke: white; */
  position: relative;
  top: 3px;
  padding-right: 5px;
  width: 16px;
  fill: rgb(128, 126, 126);
  cursor: pointer;
}
.svgfffs {
  position: relative;
  top: 4px;
  width: 16px;
  fill: rgb(128, 126, 126);
  cursor: pointer;
}
.ifffs {
  position: relative;
  top: 1px;
  fill: rgb(128, 126, 126);
  cursor: pointer;
}
.headimg-box {
  margin-top: -10px;
}
.head-img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 10px;
  margin-top: 10px;
}
.term-cont >>> .avatar-uploader {
  border: none;
}
.head-imgs {
  width: 60px;
  height: 60px;
  border-radius: 5px;
  vertical-align: middle;
  margin-right: 10px;
}
.Descriptive-text {
  width: 100%;
  line-height: 40px;
  background: #dfdfdf;
  position: fixed;
  bottom: 0;
  left: 0;
  text-align: center;
  color: #969696;
  z-index: 100;
}

.changeenprise {
  cursor: pointer;
}
.application {
  width: 50%;
  height: 500px;
  position: fixed;
  top: 60px;
  z-index: 10000;
  background: #ffffff;
}
.avatar-uploader {
  width: 100px;
  height: 68px;
  border: 1px solid rgb(199, 198, 198);
  text-align: center;
  line-height: 68px;
}
.avatar {
  width: 100px;
  height: 68px;
}
.photo {
  position: relative;
}
.Photodetails {
  position: absolute;
  top: 30px;
  left: 120px;
  line-height: 25px;
  color: #767676;
}
.coer {
  color: #0039bf;
}
.chanen-but {
  color: #0039bf;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
}

.newenterprise {
  text-align: left;
  line-height: 35px;
  color: #767676;
  /* border-bottom: 1px solid #efefef; */
  font-size: 14px;
  padding: 0 10px 0 20px;
  cursor: pointer;
}
.newenterprise:hover {
  background: #ecf8f9;
}
.newenterprises {
  width: 100%;
  display: flex;
  justify-content: space-between;
  line-height: 35px;
  color: #767676;
  /* border-bottom: 1px solid #efefef; */
  font-size: 14px;
  padding: 0 10px 0 10px;
}
.paddingleft10 {
  padding-left: 10px;
}
.enterprisebox {
  width: 100%;
  height: 500px;
  overflow-y: scroll;
  overflow-x: hidden;
  /* border-top: 1px solid #efefef; */
}
/* .enterprisebox::-webkit-scrollbar {
  width: 0 !important;
} */
.personchange {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  padding: 12px 15px 15px 15px;
}
.passwordbox {
  width: 100%;
  margin: 5px auto 0;
  height: 50px;
  border: none;
  outline: none;
  color: #b7b7b7 100%;
}
.main-imgt {
  width: 20%;
  height: 30px;
  font-size: 14px;
  background: #dfdfdf;
  border-radius: 5px;
  border: none;
  color: aliceblue;
}
.el-input {
  width: 100%;
}
.Required {
  color: red;
  position: absolute;
  left: -10px;
}
.authtext {
  width: 80px;
  height: 22px;
  background: #e4f1f5;
  border-radius: 10px;
  color: #52c5cb;
  text-align: center;
  line-height: 22px;
  padding: 2px 3px 2px 5px;
}
.rightbor {
  border-right: 1px solid #efefef;
}
.inputinner >>> .el-input__inner {
  border: none;
}
.inputinner >>> .el-button {
  border: none;
}
.drawerbox >>> .el-dialog__body {
  text-align: center;
  padding: 0 0 0 0;
}
.drawerbox >>> .el-dialog__header {
  padding: 10px 0 10px 20px;
  border-bottom: 1px solid #efefef;
}

.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>
